import * as types from './actionTypes';  
import faqApi from '../api/faqApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFaq(data) {

  return {
    type: types.DO_FAQ, 
    data
  };
}

export function doFaqRes(data) {  
  return {
    type: types.DO_FAQ_RES, 
    data
  };
}

export function faq_list(data) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      faqApi.doFaq(data).then(data => {
        dispatch(doFaqRes(data));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
}